module.exports = __webpack_public_path__ + "static/media/unbind.bae74280.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/bind-weixin/unbind.png
// module id = 503
// module chunks = 1